<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 18H3V16H15V18ZM21 13H3V11H21V13ZM15 8H3V6H15V8Z"
      fill="#31576F"
    />
  </svg>
</template>
